import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    zIndex: 2,
    overflow: 'visible',
    animationFillMode: 'forwards'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
    background: '#283745',
    color: 'white',
    padding: spacing(1),
    paddingLeft: spacing(4),
    width: '100vw',

    [breakpoints.up('lg')]: {
      width: '100%'
    }
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    flexGrow: 1,
    [breakpoints.down('sm')]: {
      maxWidth: '668px',
      fontSize: '18px'
    }
  },
  subTitle: {
    fontSize: '16px',
    flexGrow: 1,
    [breakpoints.down('md')]: {
      fontSize: '14px'
    }
  },
  ctaSecondary: {
    fontSize: '16px',
    [breakpoints.down('sm')]: {
      fontSize: '14px',
      marginBottom: spacing(1)
    }
  },

  content: {
    background: '#2C3C4B',
    color: 'white',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(2),
    fontSize: '24px',
    lineHeight: '1.5rem',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: spacing(1)

    }
  },
  divider: {
    backgroundColor: palette.grey.shade[30],
    height: '24px',
    marginLeft: spacing(2),
    marginRight: spacing(2),
    [breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  actionButton: {
    color: 'white',
    background: '#EF7D00',
    minWidth: '170px',
    [breakpoints.down('sm')]: {
      minWidth: 'initial',
      marginBottom: spacing(1)
    }
  },
  arrowIcon: {
    marginRight: spacing(2),
    alignSelf: 'center',
    background: '#283745'
  },
  filterIcon: {
    display: 'none',
    [breakpoints.up('lg')]: {
      display: 'inline-block'
    }
  },
  arrowDown: {
    transform: 'rotate(0deg)'
  },
  arrowUp: {
    transform: 'rotate(180deg)'
  }
}))
